import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "warehouse-form" }
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"900px"}
}
const _hoisted_3 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(240px, 1fr))","gap":"14px"}
}
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.transferItem && _ctx.transferItem(...args)), ["prevent"]))
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", {
              class: "title",
              style: {"font-size":"22px"}
            }, "Transferir item"),
            _createElementVNode("p", { class: "subtitle" }, "Selecione o item e o projeto de destino.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "transfer-item" }, "Item", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "transfer-item",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.itemId) = $event))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, "Selecione um item", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.name) + " (" + _toDisplayString(item.code) + ") ", 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.itemId]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "transfer-project" }, "Projeto de destino", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "transfer-project",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.projectId) = $event))
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Sem area", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: project.id,
                  value: project.id
                }, _toDisplayString(project.name), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.projectId]
            ])
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "submit",
            disabled: _ctx.saving
          }, _toDisplayString(_ctx.saving ? 'Transferindo...' : 'Transferir'), 9, _hoisted_10),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            disabled: _ctx.saving,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, "Cancelar", 8, _hoisted_11)
        ])
      ], 32)
    ])
  ]))
}